<template>
    <div class="agent-page">
        <div style="display: flex; flex-direction: column; text-align: start;">
            <h2 class="page-title" >企业采购--公开招标项目流程--招标项目编号：E1101050893002128　招标项目名称：中山大厦项目</h2>
            <div style="display: flex; align-items: center; justify-content: space-between;">
                <h2 class="page-title" style="margin-top: 10px;">开标一览表</h2>
                <el-button type="primary" icon="el-icon-arrow-left"  @click="handleBack">返回项目流程界面</el-button>
            </div>
        
        </div>

        <!-- 数据表格 -->
        <div class="table-section">
            <el-table :data="tableData" v-loading="loading" border style="width: 100%" class="data-table">
                <el-table-column prop="no" label="NO." width="60" align="center" />
                <el-table-column prop="sectionCode" label="标段编码" show-overflow-tooltip />
                <el-table-column prop="sectionName" label="标段名称" show-overflow-tooltip />
                <el-table-column prop="sectionCategory" label="标段分类" show-overflow-tooltip />
                <el-table-column prop="estimatedPrice" label="标段合同估算价(元)" show-overflow-tooltip align="right" />
                <el-table-column label="开标记录" align="center" width="200">
                    <template slot-scope="scope">
                        <div class="action-buttons">
                            <el-button type="text" size="small" @click="handleAdd(scope.row)" class="action-btn">
                                添加
                            </el-button>
                            <br>
                            <el-button type="text" size="small" @click="handleExport(scope.row)" class="action-btn">
                                导出开标一览表
                            </el-button>
                        </div>
                    </template>
                </el-table-column>
            </el-table>
        </div>

        <!-- 分页 -->
        <div class="pagination-section">
            <el-pagination 
                @size-change="handleSizeChange" 
                @current-change="handleCurrentChange"
                :current-page="pagination.currentPage" 
                :page-sizes="[10, 20, 50, 100]" 
                :page-size="pagination.pageSize"
                layout="total, sizes, prev, pager, next, jumper" 
                :total="pagination.total" 
                class="pagination" />
        </div>

        <!-- 添加开标记录弹窗 -->
        <el-dialog
            title="添加开标记录"
            :visible.sync="addRecordDialogVisible"
            width="80%"
            :close-on-click-modal="false"
            :append-to-body="true"
            class="add-record-dialog">
            
            <el-form
                ref="recordFormRef"
                :model="recordForm"
                :rules="recordFormRules"
                label-width="120px"
                class="record-form">
                
                <!-- 基本信息 -->
                <el-form-item label="开标参与人:" prop="participants" required>
                    <el-input 
                        v-model="recordForm.participants" 
                        placeholder="请输入开标参与人"
                        style="width: 300px;">
                    </el-input>
                </el-form-item>

                <el-form-item label="开标时间:" prop="openingTime" required>
                    <app-date-picker
                        v-model="recordForm.openingTime"
                        type="datetime"
                        placeholder="请选择开标时间"
                        format="yyyy-MM-dd HH:mm:ss"
                        value-format="yyyy-MM-dd HH:mm:ss"
                        style="width: 300px;">
                    </app-date-picker>
                </el-form-item>

                <el-form-item label="模板列表:" prop="templateId" required>
                    <el-select 
                        v-model="recordForm.templateId" 
                        placeholder="请选择开标记录模板"
                        style="width: 300px;">
                        <el-option label="模板1" value="template1"></el-option>
                        <el-option label="模板2" value="template2"></el-option>
                        <el-option label="模板3" value="template3"></el-option>
                    </el-select>
                </el-form-item>

                <!-- 富文本编辑器 -->
                <el-form-item label="内容:" prop="content" required>
                    <RichTextEditor
                        v-model="recordForm.content"
                        :height="300"
                        placeholder="请输入内容..."
                        toolbar-type="default"
                    />
                </el-form-item>

                <!-- 附件部分 -->
                <el-form-item label="附件:">
                    <div class="attachment-content">
                        <el-button type="primary" size="small" @click="handleSelectFile" class="select-file-btn">
                            选取文件
                        </el-button>
                        <el-table :data="attachmentList">
                            <el-table-column prop="fileName" label="文件名" align="center"></el-table-column>
                            <el-table-column prop="uploadTime" label="上传时间" align="center"></el-table-column>
                            <el-table-column label="操作" align="center">
                                <template slot-scope="scope">
                                    <el-button type="text" size="mini" @click="handleDeleteFile(scope.$index)">删除</el-button>
                                </template>
                            </el-table-column>
                        </el-table>
                    </div>
                </el-form-item>
            </el-form>
            
            <div slot="footer" class="dialog-footer">
                <el-button type="primary" @click="handleSaveDraft" class="action-btn">暂存</el-button>
                <el-button type="primary" @click="handleSubmit" class="action-btn">提交</el-button>
            </div>
        </el-dialog>
    </div>
</template>

<script>
import RichTextEditor from '@/components/common/RichTextEditor.vue'

export default {
    name: 'BidOpeningSummary',
    components: {
        RichTextEditor
    },
    data() {
        return {
            loading: false,
            tableData: [
            ],
            pagination: {
                currentPage: 1,
                pageSize: 10,
                total: 1
            },
            // 弹窗相关数据
            addRecordDialogVisible: false,
            recordForm: {
                participants: '',
                openingTime: '',
                templateId: '',
                content: ''
            },
            recordFormRules: {
                participants: [
                    { required: true, message: '请输入开标参与人',  }
                ],
                openingTime: [
                    { required: true, message: '请选择开标时间',  }
                ],
                templateId: [
                    { required: true, message: '请选择模板',  }
                ],
                content: [
                    { required: true, message: '请输入内容', }
                ]
            },
            attachmentList: []
        }
    },
    methods: {
        // 返回上一页
        handleBack() {
            this.$router.go(-1)
        },
        
        // 添加开标记录
        handleAdd(row) {
            this.addRecordDialogVisible = true
            // 重置表单数据
            this.recordForm = {
                participants: '',
                openingTime: '',
                templateId: '',
                content: ''
            }
            this.attachmentList = []
        },
        
        // 导出开标一览表
        handleExport(row) {
            this.$confirm('确定要导出该标段的开标一览表吗？', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                // 这里调用导出接口
                this.$message.success('导出成功')
            }).catch(() => {
                this.$message.info('已取消导出')
            })
        },
        
        // 分页相关方法
        handleSizeChange(val) {
            this.pagination.pageSize = val
            this.loadData()
        },
        
        handleCurrentChange(val) {
            this.pagination.currentPage = val
            this.loadData()
        },
        
        // 加载数据
        loadData() {
            this.loading = true
            // 这里调用接口加载数据
            setTimeout(() => {
                this.loading = false
            }, 500)
        },
        
        // 弹窗相关方法
        handleSelectFile() {
            // 创建文件输入元素
            const input = document.createElement('input')
            input.type = 'file'
            input.multiple = true
            input.onchange = (e) => {
                const files = Array.from(e.target.files)
                files.forEach(file => {
                    this.attachmentList.push({
                        fileName: file.name,
                        uploadTime: new Date().toLocaleString()
                    })
                })
            }
            input.click()
        },
        
        handleDeleteFile(index) {
            this.attachmentList.splice(index, 1)
        },
        
        handleSaveDraft() {
            // 暂存不需要验证表单
            this.$message.success('暂存成功')
            this.addRecordDialogVisible = false
        },
        
        handleSubmit() {
            // 提交前验证表单
            this.$refs.recordFormRef.validate((valid) => {
                if (valid) {
                    this.$message.success('提交成功')
                    this.addRecordDialogVisible = false
                } else {
                    this.$message.error('请完善必填信息')
                    return false
                }
            })
        }
    },
    
    mounted() {
        this.loadData()
    }
}
</script>

<style lang="less" scoped>
@import '@/assets/css/agent-common.css';

.table-section {
    padding: 20px;
    border-radius: 8px;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

.data-table {
    .action-buttons {
        display: flex;
        flex-direction: column;
        align-items: center;
        
        .action-btn {
            color: #409EFF;
        }
    }
}

.pagination-section {
    display: flex;
    justify-content: flex-end;
    border-radius: 8px;
}

/* 弹窗样式 */
.add-record-dialog {
    .el-dialog__header {
        background: #f5f5f5;
        padding: 15px 20px;
        border-bottom: 1px solid #e6e6e6;
        
        .el-dialog__title {
            font-size: 16px;
            font-weight: 500;
        }
    }
    
    .el-dialog__body {
        padding: 20px;
    }
}

.dialog-content {
    .basic-info-section {
        margin-bottom: 20px;
        
        .info-item {
            display: flex;
            align-items: center;
            margin-bottom: 15px;
            
            .info-label {
                width: 120px;
                font-size: 14px;
                color: #333;
                margin-right: 10px;
            }
            
            .info-input {
                flex: 1;
                max-width: 300px;
            }
        }
    }
}

.dialog-footer {
    text-align: center;
    padding: 15px 20px;
    
    .action-btn {
        margin: 0 10px;
        padding: 8px 20px;
    }
}
</style>
